
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions/browse-furniture",
      function () {
        return require("private-next-pages/exhibitions/browse-furniture.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions/browse-furniture"])
      });
    }
  